export const APP_DETAILS = {
  FA_NAME: 'زلال',
  EN_NAME: 'Zolal',
  AR_NAME: 'زلال',
  TJ_NAME: 'Zolal',
  FA_DESCRIPTION: 'زلال تی وی',
  EN_DESCRIPTION: 'Zolal TV',
  AR_DESCRIPTION: 'زلال تی وی',
  TJ_DESCRIPTION: 'Zolal телевизион',
};

export const APP_API = {
  PROXY_URL: 'https://www.zolal.com',
  API_PROTOCOL: 'https',
  API_SUBDOMAIN: 'www',
  API_BASE: 'zolal.com',
  API_PATH: 'api',
  API_VERSION: 'v1',
};

export const APP_GLOBAL_CONFIG = {
  APP_VERSION: '1.4.0',
  ROWS_PER_PAGE: 5,
  GOOGLE_TAG_MANAGER: 'GTM-NK6SS2W',
  LOGIN_URL: 'https://zolal.com/activate',
  APPS_URL: 'https://zolal.com/app',
};
